import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { projectService } from '../../services/projectService.js';
import { storage } from '../../utils/localStorage.js';

const EditCollaborators = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  
  const [project, setProject] = useState(null);
  const [collaborators, setCollaborators] = useState(['']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    // Find project from localStorage
    const projects = storage.getProjects();
    const foundProject = projects.find(p => p.project_id === Number(projectId));
    
    if (foundProject) {
      setProject(foundProject);
      setCollaborators(foundProject.collaborators && foundProject.collaborators.length > 0 
        ? foundProject.collaborators 
        : ['']
      );
    } else {
      setError('Project not found');
    }
  }, [projectId]);

  const handleCollaboratorChange = (index, value) => {
    const newCollaborators = [...collaborators];
    newCollaborators[index] = value;
    setCollaborators(newCollaborators);
    setError('');
    setSuccess('');
  };

  const addCollaborator = () => {
    setCollaborators([...collaborators, '']);
  };

  const removeCollaborator = (index) => {
    const newCollaborators = collaborators.filter((_, i) => i !== index);
    setCollaborators(newCollaborators.length > 0 ? newCollaborators : ['']);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Filter out empty collaborators
    const validCollaborators = collaborators.filter(email => email.trim() !== '');

    try {
      await projectService.editCollaborators(Number(projectId), validCollaborators);
      setSuccess('Collaborators updated successfully!');
      
      // Update local project state
      setProject(prev => ({
        ...prev,
        collaborators: validCollaborators
      }));
      
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
    } catch (error) {
      setError(error.error || error.message || 'Failed to update collaborators');
    } finally {
      setLoading(false);
    }
  };

  if (!project) {
    return (
      <div className="container">
        <div className="loading">Loading project...</div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="form-container" style={{ maxWidth: '600px' }}>
        <h2>Edit Collaborators</h2>
        <p style={{ marginBottom: '1rem', color: '#666' }}>
          Project: <strong>{project.project_name}</strong>
        </p>
        
        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Collaborators (Email addresses):</label>
            {collaborators.map((email, index) => (
              <div key={index} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => handleCollaboratorChange(index, e.target.value)}
                  placeholder="Enter email address"
                  disabled={loading}
                  style={{ flex: 1 }}
                />
                {collaborators.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeCollaborator(index)}
                    className="btn btn-danger"
                    disabled={loading}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            <button
              type="button"
              onClick={addCollaborator}
              className="btn btn-secondary"
              disabled={loading}
              style={{ marginTop: '0.5rem' }}
            >
              Add Collaborator
            </button>
          </div>

          <div style={{ display: 'flex', gap: '1rem' }}>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading}
              style={{ flex: 1 }}
            >
              {loading ? 'Updating...' : 'Update Collaborators'}
            </button>
            
            <button 
              type="button" 
              onClick={() => navigate('/dashboard')}
              className="btn btn-secondary"
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCollaborators;